<script lang="ts" setup>
// This layer handles and displays API related notifications, success and error messages.
import { useUiStore } from '@/store/uiStore';

const uiStore = useUiStore();
</script>

<template>
  <div class="notification-layer">
    <TransitionGroup name="fade">
      <UiToastAlert
        v-for="alert in uiStore.alerts"
        :key="alert.id"
        :variant="alert.type"
        :message="alert.message"
        @close="uiStore.removeAlert(alert.id)"
      />
    </TransitionGroup>
  </div>
</template>

<style lang="scss">
.notification-layer {
  position: absolute;
  height: 0;
  top: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  // Above the confirm overlay (UiConfirmLayer, 1000) so async toasts
  // (websocket / background-save errors) stay visible while a confirm is open.
  z-index: 1002;
}
</style>
